import React, {useState, useEffect} from 'react';
import {fetchFees} from "../../api/api";
import styles from './Info.module.css';
import Przelewy24Logo from '../../Przelewy24_logo.svg';
import {FaEnvelope, FaFacebook} from 'react-icons/fa';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFacebookMessenger} from '@fortawesome/free-brands-svg-icons';


const Info = () => {
    const [fees, setFees] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const result = await fetchFees();
            if (result.success) {
                setFees(result.data);
            }
        };

        fetchData();
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.about}>
                <p>
                    <b>Bocheńskie Towarzystwo Tenisowe</b> (BTT) jest organizacją non-profit, które swoją działalność
                    opiera na pracy społecznej jej członków.
                    Celem Towarzystwa jest prowadzenie i obsługa kortów tenisowych w Bochni oraz popularyzacja gry w
                    tenisa ziemnego.
                </p>
                <p>
                    <a href="/instructions"
                       target="_blank">Jak zarezerwować kort</a><br/>
                </p>
                <div className={styles.emailContainer}>
                    <p>Podczas korzystania z kortów tenisowych BTT obowiązuje <a href="/regulation"
                                                                                 target="_blank">Regulamin</a>.
                        Zapraszamy
                        również do zapoznania się z naszą <a href="/privacy-policy" target="_blank">Polityką
                            Prywatności</a>.
                        We wszystkich sprawach związanych z rezerwacjami lub płatnościami preferowany jest kontakt
                        mailowy.
                    </p>
                    <a href="mailto:btt.wysylka.maili@gmail.com" className={styles.emailLink}><FaEnvelope
                        size={20}/> Napisz e-mail.</a>


                </div>

            </div>
            <div className={styles.facebookGroup}>
                <p>W grupie na FB informujemy między innymi o turniejach organizowanych przez BTT, natomiast z czatu o
                    nazwie
                    'Korty BTT - dostępność' dowiesz się o ewentualnych problemach z dostępem do kortów.
                </p>
                <a href="https://www.facebook.com/groups/261960086358911" target="_blank" rel="noopener noreferrer">
                    <FaFacebook size={20}/> Dołącz do grupy na facebooku
                </a>
                <a href="https://m.me/ch/AbaDFp4REFwnbDRC/" target="_blank">
                    <FontAwesomeIcon icon={faFacebookMessenger} size={20}/>
                    Dołącz do czatu (z komórki)
                </a>

            </div>

            {/*<div className={styles.fees}>*/}
            {/*    <h2>Opłaty</h2>*/}
            {/*    <table className={styles.table}>*/}
            {/*        <thead>*/}
            {/*        <tr>*/}
            {/*            <th>Opis</th>*/}
            {/*            <th className={styles.rightAligned}>pln</th>*/}
            {/*        </tr>*/}
            {/*        </thead>*/}
            {/*        <tbody>*/}
            {/*        {fees.map((fee) => (*/}
            {/*            <tr key={fee.id}>*/}
            {/*                <td>{fee.description}</td>*/}
            {/*                <td className={styles.rightAligned}>{fee.price}</td>*/}
            {/*            </tr>*/}
            {/*        ))}*/}
            {/*        </tbody>*/}
            {/*    </table>*/}
            {/*</div>*/}
            <div className={styles.paymentOptions}>
                <h2>Opcje płatności</h2>
                <p>Płatności można realizować na dwa sposoby:</p>
                <div className={styles.przelewy24}>
                    <img src={Przelewy24Logo} alt="Logo Przelewy24"/>
                    <p>Wygodnie i szybko można zapłacić za pomocą serwisu <a
                        href="https://www.przelewy24.pl/metody-platnosci" target="_blank">Przelewy24</a>.
                        Rozpoczęcie płatności odbywa się w 'Moje Dane' , zakładka 'Płatności' </p>
                </div>
                <div className={styles.bankTransfer}>
                    <p>Alternatywnie, możesz dokonać tradycyjnego przelewu na konto BTT: <br/> <b>53 1240 5208 1111 0000
                        5474 1582</b>,
                        podając w tytule swoje Imię i Nazwisko oraz przedmiot wnoszonej opłaty. Wskazane jest aby
                        dodatkowo wysłać email z informacją o wykonanej płatności.</p>
                </div>
            </div>
            <div className={styles.legend}>
                <p>Opłata okresowa działa podobnie jak wynajem kortów na godziny, lecz przy częstej grze wychodzi
                    taniej. W wybranym okresie można rezerwować korty w wymiarze dwie godziny każdego dnia.
                    Opłatę wnosi się tylko raz i nie ponosi się już dodatkowych kosztów za inne osoby.
                    </p>
                <p>Składka rodzinna dotyczy najbliższej rodziny (Rodzice i ich dzieci w wieku do 18 lat lub uczące się
                    do 25 roku życia). Składka ulgowa przysługuje wszystkim osobom uczącym się do 25 roku życia
                    oraz tym, którzy przeżyli 60 wiosen.</p>
                <p>*) W sytuacji, gdy rezerwującym jest osoba, która opłaciła składkę btt
                    a w grze biorą udział osoby nie będące członkami BTT, rezerwujący jest obowiązany wnieść za nich
                    opłatę, proporcjonalnie do stawki godzinowej. </p>
            </div>
        </div>
    );
};

export default Info;
